/*
 * @Author: 朱亚
 * @Date: 2025-04-02 10:19:09
 * @说明：营销工具(sales)相关的所有接口地址定义
 */

// 优惠券列表
export const getCouponList = '/sales-tool/get-coupon-list'



// WEBPACK FOOTER //
// ./src/api/url/sales.js